import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import {
	ProjectDirectoryOnboardingModal,
	type ProjectDirectoryOnboardingModalProps,
} from './ui/project-directory-onboarding-modal/index.tsx';
import type { ProjectTemplateOnboardingContentProps } from './ui/project-template-onboarding-content/types.tsx';
import { ProjectTemplateOnboardingContent } from './ui/project-template-onboarding-content/index.tsx';

export const ProjectDirectoryOnboardingModalComponent = ({
	targetProduct,
	sourceComponent,
	templateKey,
}: ProjectDirectoryOnboardingModalProps): React.JSX.Element => {
	return (
		<JSErrorBoundary
			id="projectDirectoryOnboardingModal"
			packageName="crossFlowOnboardingModal"
			teamName="Galileo (Growth)"
			fallback="flag"
		>
			<ProjectDirectoryOnboardingModal
				targetProduct={targetProduct}
				sourceComponent={sourceComponent}
				templateKey={templateKey}
			/>
		</JSErrorBoundary>
	);
};

export const ProjectTemplateOnboardingContentComponent = ({
	targetProduct,
	sourceComponent,
	templateKey,
	onClose,
}: ProjectTemplateOnboardingContentProps): React.JSX.Element => {
	return (
		<JSErrorBoundary
			id="projectTemplatesOnboardingContent"
			packageName="crossFlowOnboardingModal"
			teamName="Galileo (Growth)"
			fallback="page"
		>
			<ProjectTemplateOnboardingContent
				targetProduct={targetProduct}
				sourceComponent={sourceComponent}
				templateKey={templateKey}
				onClose={onClose}
			/>
		</JSErrorBoundary>
	);
};
